import { render } from "./account-info.vue?vue&type=template&id=5be0caed"
import script from "./account-info.vue?vue&type=script&lang=js"
export * from "./account-info.vue?vue&type=script&lang=js"

import "./account-info.vue?vue&type=style&index=0&id=5be0caed&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__